__turbopack_context__.v({
  "team__right__content": "ztGHiG_team__right__content",
  "team__right__teamslist": "ztGHiG_team__right__teamslist",
  "team__right__toolbar": "ztGHiG_team__right__toolbar",
});
